import { BallPointPen } from "../../models/ballpoint_pen/ballpoint_pen";
import { BallPointPenJsEnv } from "../../models/ballpoint_pen/ballpoint_pen_js_env";
import { BallPointPenRepository } from "../../repositories/ballpoint_pen/ballpoint_pen_repository";
import { TypedEvent } from "../../typed_event";
import { BallPointPenContainer } from "../../views/pc/ballpoint_pen/ballpoint_pen_container";

const PARAMS = new URLSearchParams(window.location.search);
const PARAM_REFINECD_1 = PARAMS.get('refineCD1');
const PARAM_REFINECD_2 = PARAMS.get('refineCD2');
const PARAM_REFINECD_3 = PARAMS.get('refineCD3');

export class BallPointPenAction {
  static readonly UPDATE_EVENT = new TypedEvent<BallPointPenJsEnv>();
  private static state: BallPointPen;
  private static ballPointPenRepository: BallPointPenRepository;
  static async init() {
    this.ballPointPenRepository = new BallPointPenRepository();
    const ballPointPenMakers = await this.ballPointPenRepository.getBallPointPenMakers();
    this.state = new BallPointPen(new BallPointPenJsEnv(ballPointPenMakers, [], [], '', '', ''));
    new BallPointPenContainer(this.state.getModel()); // NOSONAR

    if (PARAM_REFINECD_1 !== null && PARAM_REFINECD_1 !== '' && PARAM_REFINECD_2 !== null && PARAM_REFINECD_2 !== '') {
      const ballPointPenSeries = await this.ballPointPenRepository.getBallPointPenSeries(PARAM_REFINECD_1);
      const ballPointPenSizes = await this.ballPointPenRepository.getBallPointPenSizes(PARAM_REFINECD_1, PARAM_REFINECD_2);
      this.state.updateModel(ballPointPenSeries, ballPointPenSizes, PARAM_REFINECD_1, PARAM_REFINECD_2, String(PARAM_REFINECD_3));
      this.UPDATE_EVENT.trigger(this.state.getModel());
    }
  }

  static async drillDownSeries(selectedMaker: string) {
    if (selectedMaker === '') {
      this.state.updateSeries([], selectedMaker);
    } else {
      const ballPointPenSeries = await this.ballPointPenRepository.getBallPointPenSeries(selectedMaker);
      this.state.updateSeries(ballPointPenSeries, selectedMaker);
    }
    this.UPDATE_EVENT.trigger(this.state.getModel());
  }

  static async drillDownSizes(selectedMaker: string, selectedSeries: string) {
    if (selectedSeries === '') {
      this.state.updateSizes([], selectedSeries);
    } else {
      const ballPointPenSizes = await this.ballPointPenRepository.getBallPointPenSizes(selectedMaker, selectedSeries);
      this.state.updateSizes(ballPointPenSizes, selectedSeries);
    }
    this.UPDATE_EVENT.trigger(this.state.getModel());
  }

  static async updateSelectedSize(selectedSize: string) {
    this.state.updateSelectedSize(selectedSize);
    this.UPDATE_EVENT.trigger(this.state.getModel());
  }
}
